import ExerciseCardAPI from '@/apis/business/teacher/exercise-card-api.js'
import SubjectAPI from '@/apis/business/common/subject-api'

export default {
  namespaced: true,

  state: {
    exerciseCard: {},
    listExerciseCard: [],
    exerciseCardResult: {},
    listAssignment: {}
  },

  getters: {},

  mutations: {
    setExerciseCard (state, exerciseCard) {
      state.exerciseCard = exerciseCard
    },

    setListExerciseCardPaging (state, exerciseCardResult) {
      state.exerciseCardResult = exerciseCardResult
    },

    setListExerciseCard (state, listExerciseCardRes) {
      state.listExerciseCard = listExerciseCardRes
    },
    setListAssignment (state, listAssignment) {
      state.listAssignment = listAssignment
    }
  },

  actions: {
    /**
     * @description hàm lấy thông tin bài tâp
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    getSubmitExerciseById (context, exerciseCardId) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`exercise-card-detail/${exerciseCardId}`)
          .then((res) => {
            context.commit('setExerciseCard', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách bài tập theo lớp
     * VVHung
     * @param {*} context
     * @param {*} param
     * @returns danh sách exercise card
     */
    getListExerciseCardByClassCode (context, param) {
      const query =
        `classCode=${param.ClassCode ? param.ClassCode : ''}` +
        `&type=${param.Type}` +
        `&subjectCode=${param.SubjectCode ? param.SubjectCode : ''}` +
        `&text=${param.Text ? param.Text : ''}` +
        `&sortType=${param.SortType}` +
        `&takeAll=${param.takeAll ? true : ''}`
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`list?${query}`)
          .then((res) => {
            context.commit('setListExerciseCard', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách bài tập theo lớp
     * VVHung
     * @param {*} context
     * @param {*} param
     * @returns danh sách exercise card
     */
    getListExerciseCardPagingByClassCode (context, param) {
      const query =
        `classCode=${param.ClassCode ? param.ClassCode : ''}` +
        `&type=${param.Type}` +
        `&subjectID=${param.SubjectID ? param.SubjectID : ''}` +
        `&text=${param.Text ? param.Text : ''}` +
        `&sortType=${param.SortType}` +
        `&skip=${param.Skip}` +
        `&take=${param.Take}` +
        `&takeAll=${param.takeAll ? true : ''}`
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`paging?${query}`)
          .then((res) => {
            context.commit('setListExerciseCard', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy dữ liệu tổng quan tình hình giao bài
     * VVHung
     * @param {*} context
     * @param {*} param
     * @returns danh sách exercise card
     */
    getDataAssignmentStatus (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`assignment/${params.classCode}?takeAll=${params?.takeAll}`)
          .then((res) => {
            context.commit('setListAssignment', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách bài tập màn hình tổng quan
     * VVHung
     * @param {*} context
     * @param {*} param
     * @returns danh sách exercise card
     */
    getListExerciseCardOverview (context, param) {
      const query =
        `classCode=${param.ClassCode ? param.ClassCode : ''}` +
        `&type=${param.Type}` +
        `&subjectID=${param.SubjectID ? param.SubjectID : ''}` +
        `&text=${param.Text ? param.Text : ''}` +
        `&sortType=${param.SortType}` +
        `&skip=${param.Skip}` +
        `&take=${param.Take}` +
        `&takeAll=${param.takeAll ? param.takeAll : ''}`
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`overview?${query}`)
          .then((res) => {
            context.commit('setListExerciseCardPaging', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách môn học
     * @param {} context
     * @param {*} schoolLevel
     * @returns
     */
    getSubjectList (context, schoolLevel) {
      return new Promise((resolve, reject) => {
        SubjectAPI.getAsync(`schoolLevel/${schoolLevel}`)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
